import { render } from "./ImageCategories.vue?vue&type=template&id=40f2c168"
import script from "./ImageCategories.vue?vue&type=script&lang=ts"
export * from "./ImageCategories.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout});
